// Set up a var for the GoogleMaps stuff
let Geocoder;
let GoogleMap;
let GoogleMapsLoader = {};
let MAP_IS_READY = false;

// Find the page
const page = document.querySelector('.js-locations');
// Find the results list
const list = page.querySelector('.js-locations__list');
// Find the map
const map = page.querySelector('.js-locations__map');
// Find the filters form
const form = page.querySelector('.js-locations__filters');
// Find the regions select
const regionSelect = form.querySelector('#LocationsRegion');
// Find the services select
const serviceSelect = form.querySelector('#LocationsService');
// Find the postcode input
const postcodeInput = form.querySelector('#LocationsPostcode');

// Keep an array of locations
const locations = [];
// Keep all the filtered locations in an array
const results = [];
// Set up and array of markers
const markers = [];
// Set up vars for filters
let service = null;
let region = null;

// Map Observer
const MapObserver = new IntersectionObserver(entries => {
  // If the map is in view
  if (entries[0].isIntersecting) {
    // Load the Google Maps API, then render the map
    GoogleMapsLoader.load().then(() => renderMap());
    // Stop observing the map
    MapObserver.disconnect();
  }
});

// Loop all the window locations data to pair them with the items in the list
window.locations.forEach(item => {
  // Find the item in the list
  const template = document.getElementById(item.id);

  // Make the lat and lng numbers
  item.lat = parseFloat(item.lat);
  item.lng = parseFloat(item.lng);

  // Store the item in an object
  const obj = {
    template,
    data: item
  };

  // If the item exists
  if (!template) return;

  // Add the item to the locations array
  locations.push(obj);
  // Addf the item to the results array by default
  results.push(obj);
});

// A function to render the map with styles
function renderMap() {
  // Set the map as ready
  MAP_IS_READY = true;

  // Create a new Google Map
  GoogleMap = new window.google.maps.Map(map, {
    center: {
      lat: -38,
      lng: 175.5
    },
    zoom: 7,
    streetViewControl: false,
    styles: [{
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#d3d3d3"
      }]
    }, {
      "featureType": "transit",
      "stylers": [{
        "color": "#808080"
      }, {
        "visibility": "off"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#b3b3b3"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "road.local",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#ffffff"
      }, {
        "weight": 1.8
      }]
    }, {
      "featureType": "road.local",
      "elementType": "geometry.stroke",
      "stylers": [{
        "color": "#d7d7d7"
      }]
    }, {
      "featureType": "poi",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#ebebeb"
      }]
    }, {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [{
        "color": "#a7a7a7"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#efefef"
      }]
    }, {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#696969"
      }]
    }, {
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#737373"
      }]
    }, {
      "featureType": "poi",
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "poi",
      "elementType": "labels",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "geometry.stroke",
      "stylers": [{
        "color": "#d6d6d6"
      }]
    }, {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "poi",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#dadada"
      }]
    }]
  });

  // Update the markers
  updateMarkers();
}
;
function initPostcodeSearch() {
  GoogleMapsLoader.load().then(() => initGeocoder());
  postcodeInput.removeEventListener('focus', initPostcodeSearch);
}
function initGeocoder() {
  // Set up a new Geocoder
  Geocoder = new window.google.maps.Geocoder();
}
function updateMarkers() {
  // Return if the map is not ready
  if (!MAP_IS_READY) return;

  // Remove all the markers from the map
  markers.forEach(marker => marker.setMap(null));

  // Clear the markers array
  markers.length = 0;

  // Loop all the results
  results.forEach(item => {
    // Create a new marker
    const marker = new window.google.maps.Marker({
      map: GoogleMap,
      title: item.data.title,
      position: {
        lat: item.data.lat,
        lng: item.data.lng
      }
    });
    if (item.data.marker) {
      // Extracting url, width, and height from item.data.marker
      const {
        url,
        width,
        height
      } = item.data.marker;

      // Creating a google.maps.Icon object for the custom icon
      const customIcon = {
        url: url,
        // URL of the image
        scaledSize: new google.maps.Size(width / 2, height / 2),
        // Scaling the icon
        anchor: new google.maps.Point(width / 4, height / 2) // Setting the anchor point
      };

      // Assuming you have a marker variable for a google.maps.Marker instance
      // Set the custom icon to the marker
      marker.setIcon(customIcon);
    }

    // Add the info window to the marker
    marker.infoWindow = renderInfoWindow(item);
    marker.open = false;

    // When the marker is clicked
    marker.addListener('click', () => {
      // Close all the info windows
      markers.forEach(m => {
        if (m === marker) return;
        m.infoWindow.close();
        m.open = false;
      });

      // If the marker is open, close it
      if (marker.open) {
        // Close the info window
        marker.infoWindow.close();
        marker.open = false;
        return;
      }

      // Set the marker as open
      marker.open = true;
      // Open the info window
      marker.infoWindow.open(GoogleMap, marker);
    });

    // Add the marker to the markers array
    markers.push(marker);
  });
}
function updateList() {
  // Clear the list
  list.innerHTML = '';

  // Loop all the results
  results.forEach(item => {
    list.appendChild(item.template);
  });
}
function showAllMarkers() {
  // Return if the map is not ready
  if (!MAP_IS_READY) return;
  GoogleMap.fitBounds({
    north: Math.max(...results.map(item => item.data.lat)),
    south: Math.min(...results.map(item => item.data.lat)),
    east: Math.max(...results.map(item => item.data.lng)),
    west: Math.min(...results.map(item => item.data.lng))
  });
}
function updatePostcodeSearch() {
  // If the postcode is less than 4 characters, return
  if (postcodeInput.value.length < 4) return showAllMarkers();

  // Find the location of the postcode with the Geocoder limited to New Zealand
  Geocoder.geocode({
    address: postcodeInput.value,
    componentRestrictions: {
      country: 'NZ'
    }
  }, (response, status) => {
    // If the status is not OK, return
    if (status !== 'OK') return;

    // If there are no results, return
    if (!response.length) return showAllMarkers();

    // Find the lat and lng of the postcode
    const lat = response[0].geometry.location.lat();
    const lng = response[0].geometry.location.lng();

    // Find the closest location
    let closest = null;
    let distance = null;
    const order = [];

    // Loop all the results
    results.forEach(item => {
      // Find the distance between the postcode and the location
      const d = Math.sqrt(Math.pow(lat - item.data.lat, 2) + Math.pow(lng - item.data.lng, 2));

      // If the closest is not set or the distance is less than the current closest
      if (closest === null || d < distance) {
        closest = item;
        distance = d;
      }

      // Add the item to the order array in the order of distance
      order.push({
        item,
        distance: d
      });
    });
    order.sort((a, b) => a.distance - b.distance);
    order.forEach((data, index) => {
      data.item.template.style.order = index;
    });

    // If the closest is not set, return
    if (closest === null) return;

    // If the map is not ready, return
    if (!MAP_IS_READY) return;

    // Zoom to a point between the postcode and the closest location so the user can see both
    GoogleMap.fitBounds({
      north: Math.max(lat, closest.data.lat),
      south: Math.min(lat, closest.data.lat),
      east: Math.max(lng, closest.data.lng),
      west: Math.min(lng, closest.data.lng)
    });
  });
}

// A function to filter the results based on the filters
function filterResults() {
  // Clear the results array
  results.length = 0;

  // Loop all the locations
  locations.forEach(item => {
    // If the region filter is set and the item region does not match
    if (region && region !== item.data.region) return;
    // If the service filter is set and the item service does not match
    if (service && item.data.services.indexOf(service) === -1) return;

    // Add the item to the results array
    results.push(item);
  });

  // Update the items in the list
  updateList();
  // Update the markers on the map
  updateMarkers();
  // Update the postcode search
  updatePostcodeSearch();
}
;
function renderInfoWindow(item) {
  const heading = item.data.title ? `<h5 class="info-window__heading">${item.data.title}</h5>` : '';
  const address = item.data.address ? `<p class="info-window__detail">${item.data.address}</p>` : '';
  const phone = item.data.phone ? `
    <p class="info-window__detail">
      <span class="info-window__label">P</span>
      <a href="tel:${item.data.phone}">${item.data.phone}</a>
    </p>` : '';
  const fax = item.data.fax ? `
    <p class="info-window__detail">
      <span class="info-window__label">F</span>
      <a href="fax:${item.data.fax}">${item.data.fax}</a>
    </p>` : '';
  const email = item.data.email ? `
    <p class="info-window__detail">
      <span class="info-window__label">E</span>
      <a href="mailto:${item.data.email}">${item.data.email}</a>
    </p>` : '';
  const link = item.data.link ? `
    <p class="info-window__detail">
      <a href="${item.data.link}" class="info-window__link read-more" aria-label="Read more about this clinic">Read more</a>
    </p>` : '';

  // set up a new template for the info window
  const template = `
    <div class="info-window">
      ${heading}
      ${address}
      ${phone}
      ${fax}
      ${email}
      ${link}
    </div>
  `;
  return new window.google.maps.InfoWindow({
    content: template
  });
}
function updateRegionOptions() {
  let serviceID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  // If there is no service ID, enable all the options
  if (!serviceID) {
    // Enable all the options
    [...regionSelect.options].forEach(option => {
      option.disabled = false;
    });
    return;

    // regionSelect.SimpleSelector.update();
  }

  // Check each region to see if it has the service
  window.regions.forEach(region => {
    // Find the option
    const option = regionSelect.querySelector(`option[value="${region.id}"]`);
    // Make sure the option exists
    if (!option) return;

    // Disable the option if the service is not available
    if (region.services.indexOf(serviceID) === -1) option.disabled = true;

    // Otherwise enable the option
    else option.disabled = false;
  });
}
function updateServiceOptions() {
  let regionID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  // Find the region
  const region = regionID ? window.regions.find(region => region.id === regionID) : null;
  // Create a Set of services for quick lookup if the region exists
  const serviceSet = region ? new Set(region.services) : null;

  // Iterate over the options once
  [...serviceSelect.options].forEach(option => {
    // Don't disable the empty option
    if (option.value === '') return;

    // Enable the option if there is no region or if it exists in the serviceSet, otherwise disable it
    option.disabled = serviceSet ? !serviceSet.has(option.value) : false;
  });
}

// When the region select changes
regionSelect.addEventListener('change', () => {
  region = regionSelect.value || null;

  // Filter the results
  filterResults();

  // Update the service options
  updateServiceOptions(region);
});

// When the service select changes
serviceSelect.addEventListener('change', () => {
  service = serviceSelect.value || null;

  // Filter the results
  filterResults();

  // Update the region options
  updateRegionOptions(service);
});

// When the postcode input changes, we need to look at all the results to find the closest to the postcode
postcodeInput.addEventListener('input', () => {
  // Find and replace any characters that are not numbers
  postcodeInput.value = postcodeInput.value.replace(/[^0-9]/g, '');
  updatePostcodeSearch();
});

// Prevent the form from submitting
form.addEventListener('submit', e => e.preventDefault());
Promise.all([import('scripts/marmalade/components/google-maps')]).then(_ref => {
  let [moduleGoogleMapsLoader] = _ref;
  GoogleMapsLoader.load = moduleGoogleMapsLoader.default;

  // Watch for the postcode input to be focused
  postcodeInput.addEventListener('focus', initPostcodeSearch);
  // Watch for the map to be in view
  MapObserver.observe(map);
});